<template>
  <div class="min-h-screen flex flex-col bg-carpatina-bg font-sans selection:bg-carpatina-portocaliu selection:text-white">
    
    <header class="bg-white shadow-sm sticky top-0 z-50 border-b-4 border-carpatina-verde">
      <div class="max-w-7xl mx-auto px-4 h-16 md:h-20 flex justify-between items-center gap-4">
        
        <router-link to="/" class="flex items-center gap-3 shrink-0">
          <img src="@/assets/logo.png" alt="Carpatina Prodcom Logo" class="h-10 md:h-12 w-auto hover:scale-105 transition transform"> 
          
          <div class="flex flex-col">
              <span class="text-xl font-black text-carpatina-verde tracking-tighter uppercase leading-none">Carpatina</span>
              <span class="text-xs font-bold text-carpatina-gri tracking-[0.2em] uppercase leading-none">Prodcom</span>
          </div>
        </router-link>

        <nav class="hidden xl:flex items-center gap-8 font-bold text-sm uppercase">
          <router-link v-for="link in navLinks" :key="link.path" :to="link.path" v-slot="{ isExactActive }">
            <span :class="['transition-all duration-300 pb-1 border-b-2 tracking-wide', isExactActive ? 'text-carpatina-verde border-carpatina-portocaliu' : 'text-carpatina-gri border-transparent hover:text-carpatina-portocaliu']">
              {{ link.name }}
            </span>
          </router-link>
        </nav>

        <div class="flex items-center gap-2 md:gap-4">
          <div class="relative" ref="cartRef">
            <button @click="toggleCart" 
                    class="p-2.5 rounded-xl hover:bg-gray-100 transition relative text-carpatina-gri hover:text-carpatina-portocaliu border border-transparent hover:border-gray-200">
              <ShoppingCart :size="22" />
              <transition name="scale">
                <span v-if="cart.totalItems > 0" class="absolute top-1 right-1 flex items-center justify-center h-4 w-4 bg-carpatina-portocaliu text-white text-[10px] font-black rounded-full border-2 border-white shadow-sm">
                  {{ cart.totalItems }}
                </span>
              </transition>
            </button>

            <transition name="fade-slide">
              <div v-if="showCartDropdown" 
                   class="absolute right-[-50px] md:right-0 mt-4 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden z-50 origin-top-right">
                <div class="bg-carpatina-gri p-4 text-white flex justify-between items-center shadow-md relative z-10">
                  <div class="flex items-center gap-2">
                    <ShoppingCart :size="16" /> 
                    <span class="text-xs font-black uppercase tracking-widest leading-none mt-0.5">Lista de Ofertă</span>
                  </div>
                </div>
                
                <div v-if="cart.totalItems === 0" class="p-8 text-center text-gray-400 flex flex-col items-center gap-3 bg-gray-50">
                  <Package :size="32" class="opacity-40" />
                  <span class="text-xs italic font-bold">Nu ai adăugat niciun produs.</span>
                </div>

<div v-else class="flex flex-col max-h-[250px]">
                  <div class="overflow-y-auto p-3 space-y-2 bg-gray-50 custom-scrollbar">
                    
                    <div v-for="item in cartItemsWithDetails" :key="item.productId" 
                         class="flex items-center gap-3 bg-white p-2 rounded-xl shadow-sm border border-gray-100 group">
                      
                      <div class="w-10 h-10 rounded-lg bg-gray-100 overflow-hidden shrink-0 flex items-center justify-center">
                        <img v-if="item.poza" :src="'https://carpatinaprodcom.ro/api' + item.poza" class="w-full h-full object-cover">
                        <Package v-else :size="16" class="text-gray-300" />
                      </div>
                      
                      <div class="flex-1 min-w-0">
                        <p class="text-[10px] font-black uppercase text-carpatina-gri truncate" :title="item.nume">{{ item.nume }}</p>
                        <p class="text-[10px] text-gray-500 font-bold mt-0.5">Cantitate: <span class="text-carpatina-portocaliu">{{ item.quantity }}</span></p>
                      </div>
                      
                      <button @click.stop="cart.remove(item.productId)" class="p-1.5 text-gray-300 hover:text-red-500 transition shrink-0" title="Șterge produs">
                        <Trash2 :size="14" />
                      </button>

                    </div>

                  </div>
                  
                  <div class="p-4 bg-white border-t border-gray-100">
                    <router-link to="/cerere-oferta" @click="showCartDropdown = false" 
                                 class="bg-carpatina-verde hover:bg-carpatina-portocaliu text-white flex justify-center items-center py-3 rounded-xl text-xs font-black uppercase tracking-wider transition-all shadow-md hover:-translate-y-0.5 w-full">
                      Cere Ofertă ({{ cart.totalItems }})
                    </router-link>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="relative" ref="notificationRef">
            <button @click="toggleNotifications" 
                    class="p-2.5 rounded-xl hover:bg-gray-100 transition relative text-carpatina-gri hover:text-carpatina-portocaliu border border-transparent hover:border-gray-200">
              <Bell :size="22" />
              <transition name="scale">
                <span v-if="unreadCount > 0" class="absolute top-2 right-2 flex h-2.5 w-2.5">
                  <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-carpatina-portocaliu opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-carpatina-portocaliu border-2 border-white"></span>
                </span>
              </transition>
            </button>

            <transition name="fade-slide">
              <div v-if="showNotifications" 
                   class="absolute right-[-50px] md:right-0 mt-4 w-72 md:w-80 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden z-50 origin-top-right">
                <div class="bg-carpatina-verde p-4 text-white flex justify-between items-center shadow-md relative z-10">
                  <div class="flex items-center gap-2">
                    <BellRing :size="16" /> 
                    <span class="text-xs font-black uppercase tracking-widest leading-none mt-0.5">Noutăți Rapide</span>
                  </div>
                  <button @click="markAllRead" class="text-[10px] underline opacity-80 hover:opacity-100 transition">Marchează citit</button>
                </div>
                <div class="max-h-80 overflow-y-auto bg-gray-50 custom-scrollbar">
                  <div v-for="alert in activeAlerts" :key="alert.id" 
                       :class="['p-4 border-b border-gray-100 text-sm hover:bg-white transition cursor-default relative', !isRead(alert.id) ? 'bg-orange-50 border-l-4 border-l-carpatina-portocaliu' : 'border-l-4 border-l-transparent']">
                    <div class="flex gap-3 items-start">
                      <div class="mt-0.5 p-1.5 bg-white rounded-lg shadow-sm text-carpatina-portocaliu shrink-0">
                        <component :is="alert.iconComponent" :size="18" />
                      </div>
                      <div class="flex-1">
                        <div class="flex justify-between items-start">
                            <p class="font-black text-carpatina-gri leading-tight mb-1 text-xs uppercase tracking-wide">{{ alert.titlu }}</p>
                            <span v-if="!isRead(alert.id)" class="w-2 h-2 rounded-full bg-carpatina-portocaliu shrink-0 ml-2"></span>
                        </div>
                        <p class="text-xs text-gray-500 leading-relaxed font-medium">{{ alert.text }}</p>
                        <p class="text-[9px] text-gray-400 mt-2 font-mono flex items-center gap-1">
                            <Clock :size="10" /> {{ formatDate(alert.data_creare) }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="activeAlerts.length === 0" class="p-12 text-center text-gray-400 flex flex-col items-center gap-3">
                    <div class="bg-gray-100 p-4 rounded-full"><BellOff :size="32" class="opacity-40" /></div>
                    <span class="text-xs italic font-bold">Nicio noutate momentan.</span>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <a href="tel:0247412068" class="bg-carpatina-verde text-white p-2.5 md:px-5 md:py-2.5 rounded-xl font-black flex items-center gap-2 hover:bg-carpatina-gri transition shadow-lg hover:-translate-y-0.5 active:translate-y-0">
            <Phone :size="20" /> 
            <span class="hidden md:inline italic uppercase tracking-wider text-xs">Sună Acum</span>
          </a>

          <button @click="mobileMenuOpen = !mobileMenuOpen" 
                  class="xl:hidden p-2.5 text-carpatina-gri bg-gray-50 hover:bg-carpatina-portocaliu hover:text-white rounded-xl transition border border-gray-200 hover:border-carpatina-portocaliu shadow-sm group">
              <Menu v-if="!mobileMenuOpen" :size="26" class="group-active:scale-90 transition" />
              <X v-else :size="26" class="group-active:scale-90 transition" />
          </button>

        </div>
      </div>

      <transition name="slide-down">
<div v-if="mobileMenuOpen" class="xl:hidden bg-white border-t border-gray-100 shadow-2xl absolute w-full z-40 overflow-y-auto max-h-[calc(100vh-80px)]">
           <nav class="flex flex-col p-4 space-y-2">
              <router-link v-for="link in navLinks" :key="link.path" :to="link.path" 
                           @click="mobileMenuOpen = false"
                           active-class="bg-green-50 text-carpatina-verde border-carpatina-verde"
                           class="font-black uppercase text-sm text-carpatina-gri py-4 px-6 rounded-2xl hover:bg-gray-50 hover:text-carpatina-portocaliu transition flex items-center gap-4 border-l-4 border-transparent">
                  <span class="w-2 h-2 bg-current rounded-full opacity-50"></span>
                  {{ link.name }}
              </router-link>
           </nav>
           <div class="bg-gray-50 p-4 text-center text-xs text-gray-400 font-bold uppercase tracking-widest border-t border-gray-100">
              Carpatina Prodcom &copy; 2026
           </div>
        </div>
      </transition>

    </header>

    <main class="flex-grow">
      <router-view />
    </main>

    <footer class="bg-carpatina-gri text-white pt-12 pb-6 relative overflow-hidden">
        <div class="absolute top-0 right-0 opacity-5 pointer-events-none">
            <Package :size="300" />
        </div>

        <div class="max-w-7xl mx-auto px-4 relative z-10">
            <div class="grid grid-cols-1 md:grid-cols-4 gap-10">
                <div class="md:col-span-2">
                    <h4 class="font-black text-xl mb-4 text-carpatina-portocaliu uppercase italic">Carpatina Prodcom</h4>
                    <p class="text-sm opacity-80 leading-relaxed mb-6 max-w-md">Partenerul tău de încredere în construcții. Livrăm calitate direct la tine pe șantier.</p>
                    <div class="text-xs text-gray-400 space-y-1 mb-6 border-l-2 border-carpatina-portocaliu pl-3">
                        <p class="font-bold text-white uppercase">CARPATINA PRODCOM SRL</p>
                        <p>CUI: <span class="text-white">3653551</span></p>
                        <p>Reg. Com: <span class="text-white">J34/295/1993</span></p>
                        <p>Adresă: <span class="text-white">Strada Stadionului NR 14, Turnu Magurele</span></p>
                    </div>
                    <div class="flex gap-4 mb-6">
                        <a href="https://www.facebook.com/CarpatinaProdcom/" target="_blank"><Facebook :size="20" class="hover:text-carpatina-portocaliu cursor-pointer transition transform hover:scale-110" /></a>
                    </div>
                    <div class="flex flex-col gap-1">
                        <a href="https://anpc.ro/" target="_blank" class="text-[10px] text-gray-500 hover:text-white transition">ANPC - Autoritatea Națională pentru Protecția Consumatorilor</a>
                        <a href="https://ec.europa.eu/consumers/odr" target="_blank" class="text-[10px] text-gray-500 hover:text-white transition">SOL - Soluționarea Online a Litigiilor</a>
                    </div>
                </div>
                <div class="md:col-span-2 md:pl-20">
                    <h4 class="font-bold mb-4 uppercase text-sm tracking-wider">Link-uri Rapide</h4>
                    <ul class="space-y-2 text-sm italic">
                        <li v-for="link in footerLinks" :key="link.path">
                            <router-link :to="link.path" class="opacity-70 hover:opacity-100 hover:text-carpatina-portocaliu transition block">{{ link.name }}</router-link>
                        </li>
                        <li class="pt-4"><router-link to="/admin/login" class="text-[10px] uppercase tracking-tighter opacity-30 hover:opacity-100 transition hover:text-carpatina-portocaliu">Administrare</router-link></li>
                    </ul>
                </div>
                <div class="md:col-span-4 bg-white/5 p-8 rounded-3xl border border-white/10 backdrop-blur-sm mt-4 flex flex-col items-center text-center">
                    <h4 class="font-black text-lg mb-2 text-carpatina-portocaliu uppercase flex items-center gap-2 justify-center"><Mail :size="20" /> Abonează-te la Noutăți</h4>
                    <p class="text-xs opacity-70 mb-6 max-w-lg mx-auto">Primești oferte speciale, reduceri la bricolaj și noutăți despre stocuri direct pe mail.</p>
                    <form @submit.prevent="handleSubscribe" class="flex flex-col sm:flex-row gap-3 w-full max-w-xl mx-auto">
                        <input v-model="newsletterEmail" required type="email" placeholder="Adresa ta de email..." class="w-full flex-grow px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:border-carpatina-portocaliu transition text-sm text-center sm:text-left">
                        <button type="submit" :disabled="subLoading" class="bg-carpatina-portocaliu hover:bg-white hover:text-carpatina-gri text-white font-black uppercase text-xs px-8 py-3 rounded-xl transition-all shadow-lg disabled:opacity-50 whitespace-nowrap">{{ subLoading ? 'Se trimite...' : 'Mă Abonez' }}</button>
                    </form>
                    <p v-if="subMessage" :class="subStatus === 'success' ? 'text-green-400' : 'text-red-400'" class="text-xs font-bold mt-3 italic animate-pulse">{{ subMessage }}</p>
                </div>
            </div>
            <div class="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] text-gray-500 uppercase tracking-widest">
                <p>&copy; 2026 CARPATINA PRODCOM SRL. Toate drepturile rezervate.</p>
                <p class="flex items-center gap-1 opacity-70 hover:opacity-100 transition">Site realizat de <a href="https://www.rusin.ro" target="_blank" class="font-bold text-gray-300 hover:text-carpatina-portocaliu transition border-b border-transparent hover:border-carpatina-portocaliu">Luca Rusin</a></p>
            </div>
        </div>
    </footer>

    <a href="https://wa.me/+40768710820" target="_blank" class="fixed bottom-8 left-8 z-[50] group flex items-center flex-row-reverse transition-all">
      <span class="ml-[-25px] pl-12 pr-6 py-3 bg-carpatina-gri/90 backdrop-blur-md border border-white/10 text-white font-black uppercase text-[10px] tracking-[0.2em] rounded-r-full opacity-0 translate-x-10 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500 shadow-2xl pointer-events-none italic">
        Cere ofertă rapidă
      </span>
      <div class="relative flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-carpatina-verde to-[#075E54] rounded-full shadow-[0_0_30px_rgba(0,104,74,0.4)] group-hover:shadow-[0_0_50px_rgba(37,211,102,0.6)] transition-all duration-500 group-hover:scale-110 active:scale-95 border-4 border-white overflow-visible">
        <MessageCircle :size="35" class="text-white group-hover:-rotate-12 transition-transform duration-300" />
        <span class="absolute inset-0 rounded-full bg-carpatina-verde animate-ping opacity-25"></span>
        <span class="absolute inset-0 rounded-full border-2 border-white/20 animate-pulse"></span>
      </div>
    </a>

    <transition name="slide-up">
      <div v-if="!cookieAccepted" class="fixed bottom-0 inset-x-0 z-[60] p-4 md:p-6">
        <div class="max-w-4xl mx-auto bg-carpatina-gri text-white p-6 rounded-[2rem] shadow-2xl border-2 border-white/10 backdrop-blur-md flex flex-col md:flex-row items-center gap-6">
          <div class="flex-grow text-center md:text-left">
            <h5 class="font-black uppercase text-carpatina-portocaliu text-sm mb-1 tracking-widest">Politica de module Cookie</h5>
            <p class="text-xs opacity-80 leading-relaxed font-medium">
              Folosim module cookie pentru experiență brici. <router-link to="/politica-confidentialitate" class="underline hover:text-carpatina-portocaliu transition">Detalii.</router-link>
            </p>
          </div>
          <button @click="acceptCookies" class="bg-carpatina-portocaliu hover:bg-white hover:text-carpatina-gri text-white px-8 py-3 rounded-xl font-black text-xs uppercase transition-all shadow-lg whitespace-nowrap">
            Sunt de acord
          </button>
        </div>
      </div>
    </transition>
    
    <ChatBot />
  </div>
</template>

<script setup>
import { 
  Phone, Facebook, MessageCircle, Bell, BellOff, BellRing,
  Tag, Truck, Info, Mail, Package, AlertTriangle, Clock, Menu, X, ShoppingCart ,Trash2
} from 'lucide-vue-next';
import { ref, onMounted, computed, onUnmounted, inject } from 'vue';
import axios from 'axios';
import ChatBot from './ChatBot.vue';

// --- INJECTĂM COȘUL GLOBAL ---
const cart = inject('cart');

// --- STARE UI PENTRU COȘ ---
const showCartDropdown = ref(false);
const cartRef = ref(null);

const toggleCart = () => {
  showCartDropdown.value = !showCartDropdown.value;
  // Închidem notificările dacă deschidem coșul, ca să nu se suprapună
  if (showCartDropdown.value) showNotifications.value = false;
};

// --- ICON MAP ---
const iconMap = {
  'Tag': Tag,
  'Truck': Truck,
  'Info': Info,
  'AlertTriangle': AlertTriangle
};

// --- ALERTE LIVE ---
const showNotifications = ref(false);
const notificationRef = ref(null);
const activeAlerts = ref([]); 
const readAlerts = ref([]); 
let pollingInterval = null; 

const fetchAlerts = async () => {
  try {
    const res = await axios.get('/alerte');
    const latest = res.data.slice(0, 5);
    activeAlerts.value = latest.map(alert => ({
      ...alert,
      iconComponent: iconMap[alert.icon] || Info 
    }));
  } catch (err) {
    console.error("Eroare la încărcare alerte (polling):", err);
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('ro-RO', { day: 'numeric', month: 'short' }) + ', ' + 
         date.toLocaleTimeString('ro-RO', { hour: '2-digit', minute:'2-digit' });
};

onMounted(() => {
  fetchAlerts(); 
  pollingInterval = setInterval(fetchAlerts, 10000); 
fetchProdusePentruCos(); // <--- Tragem catalogul când se încarcă site-ul
  const saved = localStorage.getItem('carpatina_read_alerts');
  if (saved) readAlerts.value = JSON.parse(saved);

  const consent = localStorage.getItem('carpatina_cookies');
  if (!consent) cookieAccepted.value = false;
  
  window.addEventListener('click', closeOnClickOutside);
});

onUnmounted(() => { 
    if (pollingInterval) clearInterval(pollingInterval);
    window.removeEventListener('click', closeOnClickOutside); 
});

const isRead = (id) => readAlerts.value.includes(id);

const unreadCount = computed(() => {
  return activeAlerts.value.filter(a => !readAlerts.value.includes(a.id)).length;
});

const toggleNotifications = () => { 
  showNotifications.value = !showNotifications.value; 
  if (showNotifications.value) showCartDropdown.value = false;
};

const markAllRead = () => {
  const allIds = activeAlerts.value.map(a => a.id);
  readAlerts.value = [...new Set([...readAlerts.value, ...allIds])];
  localStorage.setItem('carpatina_read_alerts', JSON.stringify(readAlerts.value));
};

const closeOnClickOutside = (e) => {
  if (notificationRef.value && !notificationRef.value.contains(e.target)) {
    showNotifications.value = false;
  }
  if (cartRef.value && !cartRef.value.contains(e.target)) {
    showCartDropdown.value = false;
  }
};
// Aducem catalogul o singură dată în App.vue pentru a avea datele în coșul mini
const produseCatalog = ref([]);

const fetchProdusePentruCos = async () => {
  try {
    const res = await axios.get('/produse');
    produseCatalog.value = res.data;
  } catch (err) {
    console.error("Eroare la aducerea produselor pentru mini-coș:", err);
  }
};

// Mapăm ID-urile din coș cu datele reale din catalog
const cartItemsWithDetails = computed(() => {
  return cart.items.map(cartItem => {
    const prod = produseCatalog.value.find(p => p.id === cartItem.productId);
    return {
      ...cartItem,
      nume: prod ? prod.nume : 'Se încarcă...',
      poza: prod && prod.poze && prod.poze.length ? prod.poze[0].url : null
    };
  });
});
// --- NAV & NEWSLETTER ---
const navLinks = [
  { name: 'Acasă', path: '/' },
  { name: 'Despre Noi', path: '/despre' },
  { name: 'Produse', path: '/produse' },
  { name: 'Ofertă', path: '/cerere-oferta' }, // <--- Link-ul nou
  { name: 'Contact', path: '/contact' }
];
const footerLinks = [
  { name: 'Vezi Catalog Produse', path: '/produse' },
  { name: 'Solicită Ofertă', path: '/contact' },
  { name: 'Politică de Confidențialitate', path: '/politica-confidentialitate' },
  { name: 'Termeni și Condiții', path: '/termeni-conditii' }
];

const newsletterEmail = ref('');
const subLoading = ref(false);
const subMessage = ref('');
const subStatus = ref('');
const cookieAccepted = ref(true);
const mobileMenuOpen = ref(false);

const handleSubscribe = async () => {
  subLoading.value = true;
  subMessage.value = '';
  const fd = new FormData();
  fd.append('email', newsletterEmail.value);
  try {
    const res = await axios.post('/newsletter/subscribe', fd);
    if (res.data.status === 'success') {
       subStatus.value = 'success';
       subMessage.value = 'Te-ai abonat! Verifică inbox-ul pentru noutăți.';
       newsletterEmail.value = '';
    } else {
       subStatus.value = 'error';
       subMessage.value = res.data.message;
    }
  } catch (err) {
    subStatus.value = 'error';
    subMessage.value = 'Ceva nu a mers.';
  } finally {
    subLoading.value = false;
    setTimeout(() => { subMessage.value = '' }, 5000);
  }
};
const acceptCookies = () => {
  localStorage.setItem('carpatina_cookies', 'true');
  cookieAccepted.value = true;
};
</script>

<style scoped>
.fade-slide-enter-active, .fade-slide-leave-active { transition: all 0.2s ease-out; }
.fade-slide-enter-from, .fade-slide-leave-to { opacity: 0; transform: translateY(-10px) scale(0.95); }

.slide-down-enter-active, .slide-down-leave-active { transition: all 0.3s ease; max-height: 400px; overflow: hidden; }
.slide-down-enter-from, .slide-down-leave-to { max-height: 0; opacity: 0; }

.scale-enter-active, .scale-leave-active { transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
.scale-enter-from, .scale-leave-to { transform: scale(0); opacity: 0; }

.slide-up-enter-active, .slide-up-leave-active { transition: all 0.5s ease; }
.slide-up-enter-from, .slide-up-leave-to { transform: translateY(100%); opacity: 0; }
span { display: inline-block; transition: all 0.3s ease; }
.no-scrollbar::-webkit-scrollbar { display: none; }
.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 10px; }
.custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #f08119; }
</style>